import React from "react";

import { Action } from "../frame-stencil-drawing/action";

export const DragAndDropPreview = ({ actionData }: any) => {
  return <Action action={actionData} />;
};
